<script setup>
import { computed } from 'vue'
import { useWebSiteStore } from '@/stores/website.store'
import UserDetails from './UserDetails.vue'

defineProps({
  isMobile: { type: Boolean, default: false },
  showMenu: { type: Boolean, default: true }
})
defineEmits(['toggle'])

const websiteStore = useWebSiteStore()

const userInitials = computed(() => {
  const user = websiteStore.userData
  if (!user || !user.first_name || !user.last_name) return null
  return `${user.first_name[0]}${user.last_name[0]}`.toUpperCase()
})

const hasUserData = computed(() => userInitials.value !== null)
</script>

<template>
  <q-header elevated>
    <q-toolbar class="toolbar-gradient">
      <q-btn
        v-if="!isMobile && showMenu"
        flat
        dense
        round
        icon="mdi-menu"
        @click="$emit('toggle')"
      />
      <q-toolbar-title class="text-weight-bold">
        ZapLater
      </q-toolbar-title>
      <q-space />

      <q-btn
        flat
        dense
        round
      >
        <q-avatar
          v-if="hasUserData"
          color="white"
          text-color="secondary"
          size="2rem"
        >
          {{ userInitials }}
        </q-avatar>
        <q-icon
          v-else
          name="mdi-account-circle"
          size="2rem"
        />
        <q-menu>
          <user-details />
        </q-menu>
      </q-btn>
    </q-toolbar>
  </q-header>
</template>

<style lang="scss" scoped>
@import '@/styles/quasar.variables.scss';

.toolbar-gradient {
  background: $gradient-primary !important;
  color: #ffffff;
}

.toolbar-gradient .q-toolbar__title,
.toolbar-gradient .q-btn__content,
.toolbar-gradient .q-btn__label {
  color: #ffffff !important;
}
</style>
